import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export const QuickHub = () => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (user.isAgencyStaff) {
    return <Navigate to="/agency/portfolio" replace />;
  }

  if (user.currentTeam?.isAgencyTeam && user.currentTeam.carteBlanche === false) {
    return <Navigate to="/approvals" replace />;
  }

  return <Navigate to="/analytics" replace />;
};
